<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g id="icon">
      <line
        x1="4"
        y1="3.5"
        x2="4"
        y2="17.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
      <line
        x1="10.5"
        y1="3.5"
        x2="10.5"
        y2="17.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
      <line
        x1="17"
        y1="3.5"
        x2="17"
        y2="17.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
      <rect
        x="2.5"
        y="6.5"
        width="3"
        height="4"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="9"
        y="10.5"
        width="3"
        height="4"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="15.5"
        y="8"
        width="3"
        height="4"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
